import { useCallback, useState } from 'react';
import { useTranslation } from '@aimsos/i18n';

import { activateWorkspace, deactivateWorkspace } from '../../../../services';
import { validateApiResponse } from '../../../../shared/utils/apiResponse';

/**
 * Activate / deactivate workspace (POST /v1/workspace/activate|deactivate).
 * Call `commitWorkspaceStatusChange(nextIsActive)` after UI confirmation.
 */
export function useWorkspaceActivateToggle({
  workspaceId,
  workspace,
  statusReady,
  refetchWorkspaces,
  onSuccess,
}) {
  const { t } = useTranslation('workspaces');
  const [actionBusy, setActionBusy] = useState(false);

  const commitWorkspaceStatusChange = useCallback(
    async (nextIsActive) => {
      if (!workspaceId || !workspace || !statusReady || actionBusy) return false;

      setActionBusy(true);
      try {
        const body = { workspace_uuid: workspaceId };
        if (nextIsActive) {
          const res = await activateWorkspace(body);
          validateApiResponse(res, t('detail.actions.error'));
        } else {
          const res = await deactivateWorkspace(body);
          validateApiResponse(res, t('detail.actions.error'));
        }
        refetchWorkspaces();
        onSuccess?.();
        return true;
      } finally {
        setActionBusy(false);
      }
    },
    [workspaceId, workspace, statusReady, actionBusy, refetchWorkspaces, onSuccess, t],
  );

  return { commitWorkspaceStatusChange, actionBusy };
}
